import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueBitel = (stateDate, endDate) => {
  return `${API_PATHS.bitelRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};
export const apiRevenueAirtimeBitel = (stateDate, endDate) => {
  return `${API_PATHS.airtimeBitelRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};